var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
export function useGetRecaptchaToken(isRecaptchaEnabled) {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const getRecaptchaToken = useCallback((action) => __awaiter(this, void 0, void 0, function* () {
        let token = '';
        if (executeRecaptcha && isRecaptchaEnabled) {
            token = yield executeRecaptcha(action);
        }
        return token;
    }), [executeRecaptcha, isRecaptchaEnabled]);
    return { getRecaptchaToken };
}
